export default {"src":"/_next/static/media/furniture.d59a0197.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};